/**
 * @generated SignedSource<<ac850f5d67a2c4fc08284f9229500307>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectFormQuery$variables = Record<PropertyKey, never>;
export type ProjectFormQuery$data = {
  readonly current_account: {
    readonly id: number;
    readonly user_accounts: ReadonlyArray<{
      readonly id: number;
      readonly user: {
        readonly first_name: string | null | undefined;
        readonly id: number;
        readonly last_name: string | null | undefined;
      };
    }>;
  } | null | undefined;
};
export type ProjectFormQuery = {
  response: ProjectFormQuery$data;
  variables: ProjectFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "accounts",
    "kind": "LinkedField",
    "name": "current_account",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "user_accounts",
        "kind": "LinkedField",
        "name": "user_accounts",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "users",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "first_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "last_name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectFormQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProjectFormQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "655187cbcc07c0ddcd89492d60b50283",
    "id": null,
    "metadata": {},
    "name": "ProjectFormQuery",
    "operationKind": "query",
    "text": "query ProjectFormQuery {\n  current_account {\n    id\n    user_accounts {\n      id\n      user {\n        id\n        first_name\n        last_name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c6cf339204fbd95f5e18a43d425d574";

export default node;
